var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"left-part"},[_c('user-header'),_c('menu-list')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }